/**
 * Privacidade / LGPD (#74 / RNF-L04) — constantes e validação puras compartilhadas
 * entre `api` (persistência) e `web` (formulário/consentimento).
 */

/** Versão vigente da política de privacidade — registrada no consentimento. */
export const POLITICA_PRIVACIDADE_VERSAO = '2026-07-01';

/** Documento padrão do consentimento (aceite da política de privacidade). */
export const CONSENTIMENTO_DOC_PADRAO = 'politica_privacidade';

/** Tipos de solicitação do titular (LGPD art. 18). */
export const TITULAR_TIPOS = ['acesso', 'correcao', 'eliminacao'] as const;
export type TitularTipo = (typeof TITULAR_TIPOS)[number];

/** Rótulos amigáveis dos tipos de solicitação. */
export const TITULAR_TIPO_LABEL: Record<TitularTipo, string> = {
  acesso: 'Acesso aos meus dados',
  correcao: 'Correção de dados',
  eliminacao: 'Eliminação de dados',
};

/** Type guard: `v` é um tipo de solicitação válido. */
export function isTitularTipo(v: unknown): v is TitularTipo {
  return typeof v === 'string' && (TITULAR_TIPOS as readonly string[]).includes(v);
}
